import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { FundingRoundProvider } from './context/FundingRoundContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FundingRoundProvider>
      <App />
    </FundingRoundProvider>
  </React.StrictMode>
);

